<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const CheckIcon = getIcon("CheckIcon");
</script>

{#if typeof CheckIcon === 'string'}
	<img src={CheckIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof CheckIcon === 'function'}
	<svelte:component this={CheckIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
